import React from "react";
import { Link } from "react-router-dom";
import { ImFacebook2, ImInstagram, ImTwitter } from "react-icons/im";
import { FaWhatsapp, FaHeart, FaChevronRight } from "react-icons/fa";
import { GlobalData } from "../../assets/data/GlodalData";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const sections = [
    {
      title: "Foundation",
      links: [
        { name: "About Us", path: "/aboutus" },
        { name: "Our Mission", path: "/our-mission" },
        { name: "Donate Now", path: "/donate-now" },
      ]
    },
    {
      title: "Impact",
      links: [
        { name: "Our Kids", path: "/our-kids" },
        { name: "Our Stories", path: "/our-stories" },
      ]
    },
    {
      title: "Support",
      links: [
        { name: "Contact", path: "/contactus" },
        { name: "Live Chat", path: GlobalData.company.companyWhatsapp, external: true },
      ]
    }
  ];

  return (
    <footer className="relative bg-slate-900 text-white overflow-hidden pt-24 pb-12">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-red/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mb-20">
          {/* Brand Section */}
          <div className="lg:col-span-4 capitalize">
            <Link to="/" className="text-3xl font-black tracking-tighter mb-8 block">
              SHISHU <span className="text-brand-red">HRIDAY</span>
            </Link>
            <p className="text-slate-400 text-lg leading-relaxed mb-8 max-w-sm">
              Securing the future of underprivileged children through
              world-class cardiac care and nutritional support.
            </p>
            <div className="flex gap-4">
              {[
                { icon: ImFacebook2, color: 'hover:text-brand-red', url: GlobalData.company.companyfacebook },
                { icon: ImInstagram, color: 'hover:text-brand-gold', url: GlobalData.company.companyinstagram },
                { icon: ImTwitter, color: 'hover:text-brand-gold', url: GlobalData.company.companytwitter }
              ].map((social, i) => (
                <a key={i} href={social.url} target="_blank" rel="noreferrer" className={`text-2xl transition-all ${social.color} hover:scale-110`}>
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Links Sections */}
          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-12">
            {sections.map((section) => (
              <div key={section.title}>
                <h4 className="text-slate-100 font-black uppercase tracking-widest text-sm mb-8">{section.title}</h4>
                <ul className="space-y-4">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      {link.external ? (
                        <a href={link.path} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-brand-red transition-colors flex items-center gap-2 group">
                          <FaChevronRight className="text-[8px] opacity-0 group-hover:opacity-100 transition-opacity" />
                          {link.name}
                        </a>
                      ) : (
                        <Link to={link.path} className="text-slate-400 hover:text-brand-red transition-colors flex items-center gap-2 group">
                          <FaChevronRight className="text-[8px] opacity-0 group-hover:opacity-100 transition-opacity" />
                          {link.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="glass-dark p-8 rounded-[2rem] border-white/5 flex flex-col md:flex-row items-center justify-between gap-8 mb-20">
          <div className="flex items-center gap-6">
            <div className="w-16 h-16 rounded-2xl gradient-bg flex items-center justify-center text-white text-3xl shadow-xl">
              <FaHeart className="animate-pulse" />
            </div>
            <div>
              <h3 className="text-xl font-bold">Make a difference today</h3>
              <p className="text-slate-400">100% of your donation helps child treatment.</p>
            </div>
          </div>
          <Link to="/donate-now" className="px-10 py-4 gradient-bg text-white rounded-full font-black text-lg hover-glow transition-all uppercase tracking-tighter">
            Donate Now
          </Link>
        </div>

        {/* Footer Bottom */}
        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-slate-500 font-medium">
          <a href="https://cyberspacedigital.in" target="_blank" rel="noopener noreferrer">
            <p>© {currentYear} Maintained by Cyber Space Digital.</p>
            <p className="text-[10px]">
              A Development & Designer Community ( #CSD )
            </p>
          </a>
          <p>Shishu Hriday Heart Foundation. All Rights Reserved.</p>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-4 right-4 z-[80] group">
        <a
          href={GlobalData.company.companyWhatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300"
        >
          <FaWhatsapp size={32} />

        </a>
        <div className="absolute left-full top-1/2 -translate-y-1/2 ml-4 px-4 py-2 bg-white text-slate-900 text-sm font-black rounded-xl opacity-0 group-hover:opacity-100 transition-all pointer-events-none shadow-2xl whitespace-nowrap -translate-x-4 group-hover:translate-x-0">
          Chat with us!
        </div>
      </div>
    </footer >
  );
};

export default Footer;
